import { AppRoutes } from "./AppRoutes";

export function App() {
  return <AppRoutes />;
}
